/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `tabular_ml` - tabular_ml
 * * `single_turn_chat` - single_turn_chat
 * * `text_generation` - text_generation
 * * `information_extraction` - information_extraction
 * * `conversational_agent` - conversational_agent
 * * `voice_agent` - voice_agent
 * * `concierge` - concierge
 * @export
 */
export const TaskTypeEnum = {
  tabularMl: 'tabular_ml',
  singleTurnChat: 'single_turn_chat',
  textGeneration: 'text_generation',
  informationExtraction: 'information_extraction',
  conversationalAgent: 'conversational_agent',
  voiceAgent: 'voice_agent',
  concierge: 'concierge',
} as const;
export type TaskTypeEnum = (typeof TaskTypeEnum)[keyof typeof TaskTypeEnum];

export function instanceOfTaskTypeEnum(value: any): boolean {
  for (const key in TaskTypeEnum) {
    if (Object.prototype.hasOwnProperty.call(TaskTypeEnum, key)) {
      if ((TaskTypeEnum as Record<string, TaskTypeEnum>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function TaskTypeEnumFromJSON(json: any): TaskTypeEnum {
  return TaskTypeEnumFromJSONTyped(json, false);
}

export function TaskTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskTypeEnum {
  return json as TaskTypeEnum;
}

export function TaskTypeEnumToJSON(value?: TaskTypeEnum | null): any {
  return value as any;
}
